import { HiSparkles } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

interface AiAssistantNavButtonProps {
  isOpen: boolean;
  onClick: () => void;
  compact?: boolean;
}

export default function AiAssistantNavButton({ isOpen, onClick, compact = false }: AiAssistantNavButtonProps) {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative transition-colors focus:outline-none touch-manipulation flex items-center justify-center ${
        compact
          ? `h-7 w-7 rounded-[8px] ${isOpen ? 'text-[#007AFF] bg-white shadow-sm' : 'text-[#6D6D72] active:bg-white/80'}`
          : `p-2 min-h-[44px] min-w-[44px] rounded-md ${isOpen ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:text-blue-600'}`
      }`}
      aria-label={t('aiAssistant.open', 'Open AI Assistant')}
      aria-pressed={isOpen}
      title={t('aiAssistant.title', 'AI Assistant')}
    >
      <HiSparkles size={compact ? 15 : 20} />
    </button>
  );
}
